import { render, staticRenderFns } from "./SourceManager.vue?vue&type=template&id=b0e96e44&scoped=true&"
import script from "./SourceManager.vue?vue&type=script&lang=js&"
export * from "./SourceManager.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ui.css?vue&type=style&index=0&id=b0e96e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e96e44",
  null
  
)

export default component.exports